<template>
  <div class="part1">
    <!-- 顶部导航栏 -->
    <Header></Header>
    <!-- 底部固定栏 -->
    <div class="bottomFixed">
      <!-- 奖励轮播 -->
      <Swiper></Swiper>
      <div class="doubleBtn pa">
        <div class="subscribe btn">
          <img src="../assets/images/fbzan.png" alt="" @click="gofb" />
          <!-- <a href="javascript:void(0);" style="display: flex" @click="gofb">
            <div
              style="margin: 0 auto; font-size: 32px"
              class="fb-like"
              :data-size="likeSize"
              data-href="https://pre.xiaoma.com.tw/dxz/"
              data-send="true"
              data-share="false"
              :data-width="likeW"
              :style="{ transform: likeScale }"
              :data-layout="likeLayout"
              data-show-faces="false"
              data-font="arial"
            ></div>
          </a> -->
        </div>
        <p
          class="inquire btn"
          @click="googleShop(pageInfo.appleStoreUrl)"
          v-if="ios == 'ios'"
        >
          <img src="../assets/images/iosbtn.png" alt="" />
        </p>
        <p
          class="inquire btn"
          @click="googleShop(pageInfo.googleStoreUrl)"
          v-else
        >
          <img src="../assets/images/googlebtn.png" alt="" />
        </p>
      </div>
    </div>
    <!-- 全局固定定位图片 -->
    <!-- <div class="fixed-img">
      <img src="@/assets/images/fixed-img.png" alt="" />
    </div> -->
    <!-- 播放按钮 -->
    <div class="center pr">
      <div class="playbox pa">
        <div class="make bg pa" @click="anchor2()"></div>
      </div>
      <!-- <div class="play bg pa"></div> -->
      <!-- 箭头指向 -->
      <!-- <div class="content-bottom pa">
        <div class="page-next"></div>
      </div> -->
    </div>
    <p class="text countdown" v-if="countdown.s.length > 0">
      距5月30日上市僅剩：<span
        class="text num countdown-sub"
        v-show="countdown.d.length > 0"
        >{{ countdown.d }}</span
      >
      天
      <span class="text num countdown-sub" v-show="countdown.h.length > 0">{{
        countdown.h
      }}</span>
      時
      <span class="text num countdown-sub" v-show="countdown.m.length > 0">{{
        countdown.m
      }}</span>
      分
      <span class="text num countdown-sub" v-show="countdown.s.length > 0">{{
        countdown.s
      }}</span>
      秒
    </p>
    <p class="over" v-else>活動已結束，請到商店下載體驗</p>
  </div>
</template>
<script>
/*eslint-disable */
import Header from "@/components/header";
import Swiper from "@/components/swiper";
import { shopSubscribe } from "@/js/api.js";
export default {
  name: "indexPage",
  data() {
    return {
      imgList: [1, 2, 3, 4],
      ios: "",
      canFbLike: true,
      backNum: this.$util.getItem("backShowNum") || 0,

      likeLayout: "button",
      likeW: 200,
      likeH: 80,
      likeScale: "scale(2)",
      likeSize: "large",
      countdown: {
        d: "",
        h: "",
        m: "",
        s: "",
      },
      time: 0,
    };
  },
  props: ["pageInfo"],
  components: {
    Header,
    Swiper,
  },
  created() {
    this.ios = this.$util.appSource();
  },
  mounted() {
    this.$bus.$on("point0", () => {
      this.anchor();
    });
    this.$bus.$on("num2", (res) => {
      this.backNum = res;
    });
    this.$nextTick(() => {
      this.$on("pageone", (res) => {
        this.time = res.time || 0;
        this.calcTime();
      });
    });
    // setTimeout(() => {
    //   let iframeDocument =
    //     document.getElementsByClassName("subscribe")[1].children[0].children[0].children[0]
    //       .children[0].contentWindow;
    //       // .document.getElementsByClassName('inlineBlock')
    //   console.log(iframeDocument);
    // }, 2000);
    this.fbLikeInit();
  },
  computed: {
    fblikeClass() {
      return this.canFbLike ? "fbStore" : "fbStore2";
    },
  },
  methods: {
    calcTime() {
      // var endTime = this.open
      var time = this.time;
      var t = time * 1000;
      if (t <= 0) {
        this.countdown.d = "";
        this.countdown.h = "";
        this.countdown.m = "";
        this.countdown.s = "";
        return;
      }
      var d = Math.floor(t / 1000 / 60 / 60 / 24) + "";
      this.countdown.d = d < 10 ? "0" + d : d + "";
      var h = Math.floor((t / 1000 / 60 / 60) % 24);
      this.countdown.h = h < 10 ? "0" + h : h + "";
      var m = Math.floor((t / 1000 / 60) % 60);
      this.countdown.m = m < 10 ? "0" + m : m + "";
      var s = Math.floor((t / 1000) % 60);
      this.countdown.s = s < 10 ? "0" + s : s + "";
      this.time = this.time - 1;

      setTimeout(this.calcTime, 1000);
    },
    fbLikeInit() {
      this.likeW = screen.width > 750 ? 200 : 10;
      this.likeLayout = screen.width > 750 ? "button" : "button";
      this.likeSize = screen.width > 750 ? "large" : "small";
      if (screen.width > 750) {
        // $(".ulis")[0].style.marginBottom = 0.4 + "rem";
        this.likeScale = "scale(2.7)";
      } else if (screen.width < 375) {
        this.likeScale = "scale(1.6)";
      } else {
        this.likeScale = "scale(2)";
      }

      setTimeout(() => {
        FB &&
          FB.Event.subscribe("edge.create", (d) => {
            console.error(d);
          });
      }, 50000);
    },
    gofb() {
      this.$bus.$emit("gofb");
      this.$xmlog.fbLike();
    },
    anchor() {
      let ele = document.getElementsByClassName("part1")[0];
      let eletop = ele.offsetTop;
      window.scrollTo({
        top: eletop,
        behavior: "smooth",
      });
    },
    anchor2() {
      // this.$bus.$emit("tips", "活動已結束，請到商店下載體驗");
      let ele = document.getElementsByClassName("part2")[0];
      let eletop = ele.offsetTop;
      window.scrollTo({
        top: eletop,
        behavior: "smooth",
      });
    },
    googleShop(value) {
      console.log(value);
      let phoneData = this.$util.getToken();
      if (phoneData) {
        let data = this.$util.getToken().token;
        shopSubscribe(data).then((res) => {
          // console.log(res);
          this.$xmlog.clickStore(() => {
            location.href = value;
            this.$util.setItem("backShow", true);
            this.$util.setItem("backShowNum", this.backNum + 1);
            this.$bus.$emit("num", this.backNum + 1);
          });
        });
      } else {
        this.$xmlog.clickStore(() => {
          location.href = value;
          this.$util.setItem("backShow", true);
          this.$util.setItem("backShowNum", this.backNum + 1);
          this.$bus.$emit("num", this.backNum + 1);
        });
        // this.$bus.$emit("tips", "請先預約");
        // location.href = value;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.part1 {
  position: relative;

  .countdown {
    margin-top: -0.5rem;
    text-align: center;
    color: #fff !important;
    font-size: 0.28rem !important;
    .countdown-sub {
      font-size: 0.46rem !important;
      color: red;
      display: inline-block;
    }
  }
  .over{
    margin-top: -0.5rem;
    text-align: center;
    font-size: 0.45rem;
    color: red;
  }
  .bottomFixed {
    width: 100%;
    max-width: 7.5rem;
    height: 1rem;
    background: url("../assets/images/btMenu.png") no-repeat;
    bottom: 0;
    left: 50%;
    z-index: 93;
    position: fixed;
    transform: translateX(-50%);
    background-size: 100% 100%;
    .doubleBtn {
      bottom: 0;
      right: 0;
      width: 67%;
      height: 1rem;
      .btn {
        background-size: cover;
        width: 2.2rem;
        cursor: pointer;
        img {
          width: 100%;
          vertical-align: middle;
          transform: scale(1.1);
        }
      }
      .subscribe {
        width: 3rem;
        position: absolute;
        right: 50%;
        bottom: -0.14rem;
        /deep/span {
          height: 30px !important;
          iframe {
            height: 30px !important;
            #facebook {
              width: 100%;
            }
            ._2tga._8j9w {
              height: 30px !important;
              width: 100% !important;
            }
          }
        }
        .fbStore {
          // background: url("@/assets/images/page2/fbzan2.png") no-repeat;
          background-size: contain;
          width: 3.09rem;
          text-align: center;
          height: 1rem;
          cursor: pointer;
          font-size: 1.4rem;
        }
        .fbStore2 {
          width: 3.09rem;
          text-align: center;
          // background: url("@/assets/images/page2/fbzan2_s.png") no-repeat;
          background-size: contain;
          // width: 100%;
          height: 1rem;
          cursor: pointer;
        }
      }
      .inquire {
        position: absolute;
        right: 0;
        bottom: 0;
        margin-bottom: 0.1rem;
        margin-right: 0.2rem;
      }
    }
  }
  .center {
    width: 100%;
    height: 12.2rem;
    // margin: 0 auto;
    z-index: 10;
    .playbox {
      left: 50%;
      bottom: 3%;
      transform: translateX(-50%);
      width: 100%;
      height: 1.5rem;
      .make {
        // animation: scale 1.5s infinite;
        display: block;
        width: 100%;
        height: 100%;
        background-image: url("../assets/images/page1/nowyy.png");
        // transition: 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
        background-position: center;
        cursor: pointer;
      }
    }
    .play {
      background-image: url("../assets/images/page1/bofang.png");
      width: 1.2rem;
      height: 1.2rem;
      right: 10%;
      bottom: 45%;
      background-position: center;
    }
    .content-bottom {
      width: 1rem;
      height: 0.69rem;
      bottom: 25%;
      left: 50%;
      transform: translateX(-50%);
      z-index: 97;
      .page-next {
        height: 0.5rem;
        background-image: url("../assets/images/next.png");
        animation: page-next 1.5s linear infinite;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
      }
    }
  }
}
@keyframes page-next {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(10px);
  }
}
@keyframes scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}
</style>